const currencyFormatters = {
  UYU: new Intl.NumberFormat("es-UY", {
    style: "currency",
    currency: "UYU",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }),
  USD: new Intl.NumberFormat("es-UY", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }),
};

// Formatter genérico para UI/UR (sin símbolo de moneda Intl)
const numberFormatter = new Intl.NumberFormat("es-UY", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export function formatMoney(value, currency = "UYU") {
  const normalized = Number.isFinite(Number(value)) ? Number(value) : 0;
  const upper = (currency || "UYU").toUpperCase();
  if (upper === "UI") return `UI ${numberFormatter.format(normalized)}`;
  if (upper === "UR") return `UR ${numberFormatter.format(normalized)}`;
  const key = upper === "USD" ? "USD" : "UYU";
  return currencyFormatters[key].format(normalized);
}
